
export default function BlogList() {
  return (
    <section id="experience" data-nav-tooltip="Experiences" className="pp-section pp-scrollable section dark-bg">
      <div className="container">
        <div className="row">
          <div className="col-md-12">{/* {content} */}</div>
        </div>
      </div>
    </section>
  );
}
